import { z, z as zod } from "zod";

import type { Item } from "@entities/item";

export const CreateOrderLineSchema = zod
  .object({
    id: zod.number(),
    item: zod.any(),
    quantity: z.preprocess(
      (n) => parseInt(n as string, 10),
      z.number().positive(),
    ),
  })
  .refine(
    (line) =>
      Number(line.quantity) >=
      ((line.item as Item).minimalOrderQuantity || Infinity),
    (line) => ({
      message: `You can order not less than ${line.item.minimalOrderQuantity} ${line.item.unitOfOrder}`,
      path: ["quantity"],
    }),
  );

export type CreateOrderLine = zod.infer<typeof CreateOrderLineSchema>;
